/*!
* # SeriouslyRAD
* http://www.seriouslyrad.com/
*
* Copyright (c) 2016 - 2024 Seriously RAD Limited - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*
*/

    "use strict";

    // #region Helpers

    // OData
    classFactory.create({
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                objectPropertyPathToODataPropertyPath: function (objectPropertyPath)
                {
                    return objectPropertyPath ? objectPropertyPath.replace(/\./gi, "/") : String.empty;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.oDataHelper = new classConstructor();
        }
    });

    // Server Error Helper
    classFactory.create({
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                processError: function (xhr)
                {
                    var
                        error = null,
                        jsonError = null;

                    try
                    {
                        if (xhr.responseType === "json")
                            jsonError = xhr.response;
                        else if (!xhr.responseType && typeof xhr.response === "string" && xhr.response)
                            jsonError = xhr.response.fromJson();
                    }
                    catch (e) { /* Continue regardless of error */ }

                    if (jsonError)
                        error = seriouslyrad.server.AjaxError.fromObject(jsonError, xhr);

                    if (error === null)
                        error = seriouslyrad.server.AjaxError.fromErrorMessage(xhr.response, xhr);

                    jsonError = null;

                    return error;
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            window.serverErrorHelper = new classConstructor();
        }
    });

    // #endregion

    // #region Server

    // Http Header Manager
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "HttpHeaderManager",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.headers = [];
            };
        },
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                getHeader: function (headerName)
                {
                    for (var i = 0; i < this.headers.length; i++)
                    {
                        if (this.headers[i].name.toLowerCase() === headerName.toLowerCase())
                            return this.headers[i];
                    }

                    return null;
                },
                getHeaderParameterValue: function (headerName, parameterName)
                {
                    var
                        header = this.getHeader(headerName);

                    if (header === null)
                        return null;

                    for (var i = 0; i < header.parameters.length; i++)
                    {
                        if (header.parameters[i].name.toLowerCase() === parameterName.toLowerCase())
                            return header.parameters[i].value;
                    }
                },
                setHeaderText: function (headerText)
                {
                    // TODO: Enhance to take quoted identifiers into consideration.

                    this.headerText = headerText;
                    this.headers = [];

                    var
                        lines = headerText.split("\r\n");

                    for (var i = 0; i < lines.length; i++)
                    {
                        var
                            line = lines[i].trim();

                        if (!line.length)
                            continue;

                        var
                            header = { parameters: [] },
                            indexOfColon = line.indexOf(":");

                        header.name = (indexOfColon >= 0 ? line.substr(0, indexOfColon) : line).trim();
                        this.headers.push(header);

                        if (indexOfColon === -1)
                            continue;

                        line = line.substr(indexOfColon + 1);

                        var
                            indexOfSemiColon = line.indexOf(";");

                        header.value = (indexOfSemiColon >= 0 ? line.substr(0, indexOfSemiColon) : line).trim();
                        line = line.substr(indexOfSemiColon + 1);

                        if (indexOfSemiColon === -1)
                            continue;

                        var
                            additionalParameters = line.split(";");

                        for (var j = 0; j < additionalParameters.length; j++)
                        {
                            var
                                parameter = {},
                                additionalParameter = additionalParameters[j],
                                indexOfEquals = additionalParameter.indexOf("=");

                            parameter.name = (indexOfEquals >= 0 ? additionalParameter.substr(0, indexOfEquals) : additionalParameter).trim();
                            header.parameters.push(parameter);

                            if (indexOfEquals === -1)
                                continue;

                            parameter.value = additionalParameter.substr(indexOfEquals + 1).trim();
                        }
                    }
                }
            };
        }
    });

    // Ajax Error
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "AjaxError",
        createConstructor: namespace =>
        {
            return function ()
            {
                this.status = null;
                this.type = null;
                this.message = null;
                this.stackTrace = null;
                this.validationErrors = null;
                this.reason = null;
                this.data = null;
                this.additionalData = null;
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.fromObject = (object, xhr) =>
            {
                var
                    error = new classConstructor();

                if (xhr)
                    error.status = xhr.status;

                if (object.error)
                    object = object.error;

                error.type = object.type || "Unknown Error";

                if (object.message)
                    error.message = object.message;

                if (object.stackTrace)
                    error.stackTrace = object.stackTrace;

                if (object.validationErrors)
                    error.validationErrors = object.validationErrors;

                if (object.reason)
                    error.reason = object.reason;

                if (object.subReason)
                    error.subReason = object.subReason;

                if (object.data)
                    error.data = object.data;

                if (object.additionalData)
                    error.additionalData = object.additionalData;

                return error;
            };
            classConstructor.fromErrorMessage = (errorMessage, xhr) =>
            {
                var error = new classConstructor();

                if (xhr)
                    error.status = xhr.status;

                switch (error.status)
                {
                    case 404:
                        error.type = "NotFoundApiException";
                        error.message = "The resource was not found";
                        break;
                    default:
                        error.type = "UnknownApiException";
                        error.message = errorMessage;
                        break;
                }

                return error;
            };
        }
    });

    // Ajax Request
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "AjaxRequest",
        properties: [
            { name: "dontShowDialogForErrorsOfType", type: "array" },
            { name: "settings" },
            { name: "type", type: "string" },
            { name: "webApiClient" }
        ],
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _ajax: function (settings, promise)
                {
                    if (!settings.headers)
                        settings.headers = {};

                    return namespace.AjaxRequest._ajax(this.webApiClientGet(), settings, promise, this.dontShowDialogForErrorsOfTypeGet());
                },
                _ajaxCallFailed: function (error, settings, promise)
                {
                    return namespace.AjaxRequest._ajaxCallFailed(this.webApiClientGet(), error, settings, promise, this.dontShowDialogForErrorsOfTypeGet());
                },
                _isValidOdataResponse: function (data)
                {
                    return data !== undefined && data !== null && data["@odata.context"] !== undefined;
                },

                // Public Methods
                executeAsync: function (options)
                {
                    var
                        self = this,
                        internalSettings = Object.extend(true, {}, options, self.settingsGet());

                    return (
                        self._ajax(internalSettings)
                            .then(data =>
                            {
                                return new Promise((resolve, reject) =>
                                {
                                    switch (self.typeGet())
                                    {
                                        case "API":
                                            resolve(data);
                                            break;
                                        case "ODATA":
                                            if (!data)
                                                resolve();
                                            else if (self._isValidOdataResponse(data))
                                            {
                                                if (data["@odata.count"] !== undefined)
                                                {
                                                    data.value.total = data["@odata.count"];
                                                    resolve(data.value);
                                                }
                                                else
                                                    resolve(data);
                                            }
                                            else
                                                reject(namespace.AjaxError.fromErrorMessage("Invalid data returned from the server"));
                                            break;
                                        default:
                                            resolve(data);
                                            break;
                                    }
                                });
                            })
                            .finally(() => { self = null; })
                    );
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.callQueue = [];
            classConstructor.disconnected = false;
            classConstructor.disconnectedDialog = null;
            classConstructor.triggerConnectionEvent = true;
            classConstructor.unauthenticated = false;

            classConstructor._ajax = (webApiClient, settings, promise, dontShowDialogForErrorsOfType) =>
            {
                var
                    internalPromise = promise ? promise : Promise.public(),
                    internalSettings = Object.extend(true, {
                        showLoading: true,
                        xhrFields: {
                            withCredentials: true
                        }
                    }, settings);

                if (!internalSettings.headers)
                    internalSettings.headers = {};

                if (classConstructor.disconnected || classConstructor.unauthenticated)
                    classConstructor.callQueue.push({ webApiClient: webApiClient, settings: internalSettings, promise: internalPromise });
                else
                    classConstructor._ajaxInternal(webApiClient, internalSettings, internalPromise, dontShowDialogForErrorsOfType);

                return internalPromise;
            };
            classConstructor._ajaxInternal = (webApiClient, options, promise, dontShowDialogForErrorsOfType) =>
            {
                const
                    onRequestAuthenticationData = webApiClient.onRequestAuthenticationDataGet(),
                    authenticationData = onRequestAuthenticationData ? onRequestAuthenticationData() : null;

                if (!authenticationData || !(authenticationData.scheme === "Cookies"))
                    window.cookieHelper.delete("__RequestVerificationToken");

                if (authenticationData && authenticationData.scheme === "Bearer" && authenticationData.accessToken)
                    options.headers["Authorization"] = `Bearer ${authenticationData.accessToken}`;

                $$
                    .ajax(options)
                    .then(results =>
                    {
                        const
                            xhr = results[1],
                            hasResponseMessages = xhr.getAllResponseHeaders().indexOf("RAD-Response-Messages") >= 0,
                            responseMessagesBase64 = hasResponseMessages ? xhr.getResponseHeader("RAD-Response-Messages") : null;

                        if (responseMessagesBase64)
                        {
                            var
                                responseMessages = atob(responseMessagesBase64).fromJson();

                            if (responseMessages?.length)
                            {
                                $$(document).triggerHandler("seriouslyrad.server.AjaxRequest:ResponseMessagesReceived", {
                                    responseMessages: responseMessages
                                });
                            }
                        }

                        return results;
                    })
                    .then(results =>
                    {
                        const
                            data = results[0],
                            xhr = results[1];

                        if (classConstructor.triggerConnectionEvent)
                        {
                            classConstructor.triggerConnectionEvent = false;

                            var
                                onConnected = webApiClient.onConnectedGet();

                            if (onConnected)
                                onConnected();
                        }

                        promise.resolve(data);
                    })
                    .catch(xhr =>
                    {
                        if (xhr.readyState === 0 || xhr.status <= 0 || xhr.status === 503 || !navigator.onLine)
                        {
                            classConstructor.callQueue.push({ webApiClient: webApiClient, settings: options, promise: promise, dontShowDialogForErrorsOfType: dontShowDialogForErrorsOfType });
                            classConstructor.disconnectionDetected(webApiClient, xhr);
                        }
                        else
                            classConstructor._ajaxCallFailed(webApiClient, window.serverErrorHelper.processError(xhr), options, promise, dontShowDialogForErrorsOfType);
                    });
            };
            classConstructor._ajaxCallFailed = (webApiClient, error, settings, promise, dontShowDialogForErrorsOfType) =>
            {
                switch (error.type)
                {
                    case "AuthenticationApiException":
                    case "UnauthorizedApiException":
                        {
                            classConstructor.callQueue.push({ webApiClient: webApiClient, settings: settings, promise: promise, dontShowDialogForErrorsOfType: dontShowDialogForErrorsOfType });

                            classConstructor.unauthenticated = true;

                            var
                                onUnauthenticated = webApiClient.onUnauthenticatedGet();

                            if (onUnauthenticated)
                                onUnauthenticated();

                            break;
                        }
                    case "MfaAuthenticationApiException":
                    case "ValidationApiException":
                        promise.reject(error);
                        break;
                    case "TenantAuthenticationApiException":
                        {
                            classConstructor.callQueue.push({ webApiClient: webApiClient, settings: settings, promise: promise, dontShowDialogForErrorsOfType: dontShowDialogForErrorsOfType });

                            if (!classConstructor.TenantSelectDialog)
                                classConstructor.TenantSelectDialog = new seriouslyrad.ui.web.TenantSelectDialog();

                            classConstructor.TenantSelectDialog
                                .openAsync(error.additionalData)
                                .then(result =>
                                {
                                    const
                                        response = result[1];

                                    if (response)
                                        classConstructor.processCallQueue(response?.antiForgeryToken);
                                });

                            break;
                        }
                    default:
                        {
                            if (!Array.isArray(dontShowDialogForErrorsOfType) || !dontShowDialogForErrorsOfType.contains(error.type))
                                seriouslyrad.ui.web.ErrorDialog.displayError(error);

                            promise.reject(error);
                            break;
                        }
                }
            };

            classConstructor.disconnectionDetected = (webApiClient, xhr) =>
            {
                if (classConstructor.disconnected)
                    return;

                classConstructor.disconnected = true;
                classConstructor.triggerConnectionEvent = true;

                var
                    onDisconnected = webApiClient.onDisconnectedGet();

                if (onDisconnected)
                    onDisconnected();

                if (!classConstructor.disconnectedDialog)
                    classConstructor.disconnectedDialog = new seriouslyrad.ui.web.MessageDialog();

                if (xhr.status === 503)
                {
                    classConstructor.disconnectedDialog.titleSet("Server Unavailable");
                    classConstructor.disconnectedDialog.textSet("The server is currently unavailable.");
                }
                else
                {
                    classConstructor.disconnectedDialog.titleSet("Network Error");
                    classConstructor.disconnectedDialog.textSet("A network connection issue has been detected. Please ensure you have an internet connection and click \"OK\" to try again.");
                }

                classConstructor.disconnectedDialog
                    .openAsync()
                    .then(() =>
                    {
                        classConstructor.disconnected = false;
                        classConstructor.processCallQueue();
                    });
            };
            classConstructor.processCallQueue = antiForgeryToken =>
            {
                while (classConstructor.callQueue.length > 0)
                {
                    var call = classConstructor.callQueue.shift();

                    if (antiForgeryToken && call.settings.headers)
                        call.settings.headers["X-XSRF-Token"] = antiForgeryToken;

                    classConstructor._ajax(call.webApiClient, call.settings, call.promise, call.dontShowDialogForErrorsOfType);
                }
            };
        }
    });

    // Blob Downloader
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "BlobDownloader",
        properties: [
            { name: "headers" }
        ],
        createPrototype: namespace =>
        {
            return {
                // Public Methods
                downloadAsync: function (url, $$link, overrideFileName)
                {
                    return (
                        this.executeAsync(url)
                            .then(response =>
                            {
                                const
                                    blob = response.blob,
                                    xhr = response.xhr;

                                var
                                    fileName = overrideFileName || null,
                                    contentType = xhr.getResponseHeader("content-type");

                                if (!fileName)
                                {
                                    var
                                        contentDisposition = xhr.getResponseHeader("content-disposition");

                                    if (!contentDisposition) // IE / EDGE seems not returning some response header
                                        fileName = `unnamed.${contentType.substring(contentType.indexOf("/") + 1)}`;
                                    else
                                        fileName = contentDisposition.substring(contentDisposition.indexOf("=") + 1);

                                    fileName = fileName.trim("\"");
                                }

                                if (window.navigator.msSaveOrOpenBlob) // Internet Explorer
                                    window.navigator.msSaveOrOpenBlob(new Blob([blob], { type: contentType }), fileName);
                                else
                                {
                                    if ($$link)
                                    {
                                        $$link.attr("href", window.URL.createObjectURL(blob));
                                        $$link.attr("download", overrideFileName ? overrideFileName : fileName);
                                        $$link[0].click();
                                    }
                                }

                                return Promise.resolve(blob);
                            })
                    );
                },
                executeAsync: function (url)
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        var
                            headers = self.headersGet(),
                            xhr = new XMLHttpRequest();

                        xhr.open("GET", url, true);
                        xhr.responseType = "blob";

                        if (headers)
                        {
                            for (var header in headers)
                                xhr.setRequestHeader(header, headers[header]);
                        }

                        xhr.onload = evt =>
                        {
                            if (xhr.status >= 200 && xhr.status < 300)
                                resolve({ blob: xhr.response, xhr: xhr });
                            else
                                reject({ message: `${xhr.status} error`, xhr: xhr });

                            xhr = null;
                        };

                        xhr.onerror = error =>
                        {
                            reject({ message: error, xhr: xhr });
                            xhr = null;
                        };

                        xhr.send();
                    });
                }
            };
        }
    });

    // Firebase
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "Firebase",
        properties: [
            { name: "additionalUserInfo" },
            { name: "configuration" },
            { name: "connected", type: "boolean" },
            { name: "connectionTimeoutInSeconds", type: "int" },
            { name: "providerId", type: "string" },
            { name: "user" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                connected: false,
                connectionTimeoutInSeconds: 30
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                var
                    self = this;

                self._bindEvents();

                self.onConnectionStateChanged = snapshot =>
                {
                    self.connectedSet(snapshot.val() === true);
                };
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _bindEvents: function ()
                {
                    if (window.universalLinks)
                        window.universalLinks.subscribe(null, this.onLaunchAppFromLink);
                },
                _executePromiseWithTimeout: function (promise, ignoreConnectionState)
                {
                    var
                        self = this;

                    if (!self.connectedGet() && !ignoreConnectionState)
                        return Promise.reject("Not connected");

                    return (
                        Promise
                            .race([
                                promise,
                                new Promise((resolve, reject) =>
                                {
                                    setTimeout(
                                        () =>
                                        {
                                            reject("Connection timed out");
                                        },
                                        self.connectionTimeoutInSecondsGet() * 1000
                                    );
                                })
                            ])
                    );
                },
                _processPathVariables: function (path, context)
                {
                    var
                        combinedContext = Object.extend({}, {
                            user: this.userGet()
                        }, context);

                    return path.replace(/\{([^}]+)\}/gi, (match, group) =>
                    {
                        return window.objectHelper.propertyValueByPathGet(combinedContext, group);
                    });
                },
                _setSignInPropertiesAsync: function (signInResult)
                {
                    this.providerIdSet(signInResult.additionalUserInfo.providerId);

                    switch (signInResult.additionalUserInfo.providerId)
                    {
                        case "facebook.com":
                        case "google.com":
                            {
                                this.additionalUserInfoSet(signInResult.additionalUserInfo);
                                this.userSet(signInResult.user);
                                break;
                            }
                        case "password":
                            {
                                this.additionalUserInfoSet(signInResult.additionalUserInfo);
                                this.userSet(signInResult.user);
                                break;
                            }
                    }

                    this.triggerHandler("onSignIn");

                    switch (signInResult.additionalUserInfo.providerId)
                    {
                        case "facebook.com":
                        case "google.com":
                        case "password":
                            {
                                this.onSignedIn();
                                return Promise.resolve();
                            }
                        default:
                            return Promise.reject();
                    }
                },
                _signInWithProviderAsync: function (provider)
                {
                    var
                        self = this;

                    self.providerIdSet(null);

                    if (!window.cordova)
                    {
                        return new Promise((resolve, reject) =>
                        {
                            firebase.auth()
                                .signInWithPopup(provider)
                                .then(result =>
                                {
                                    self._setSignInPropertiesAsync(result)
                                        .finally(() =>
                                        {
                                            resolve();
                                        });
                                })
                                .catch(error =>
                                {
                                    reject(error);
                                });
                        });
                    }

                    return new Promise((resolve, reject) =>
                    {
                        firebase.auth()
                            .getRedirectResult()
                            .then(result =>
                            {
                                if (!result || !result.user)
                                {
                                    firebase.auth()
                                        .signInWithRedirect(provider)
                                        .then(result =>
                                        {
                                            if (!window.cordova)
                                                return;

                                            firebase.auth()
                                                .getRedirectResult()
                                                .then(result =>
                                                {
                                                    self._setSignInPropertiesAsync(result)
                                                        .finally(() =>
                                                        {
                                                            resolve();
                                                        });
                                                })
                                                .catch(error =>
                                                {
                                                    reject(error);
                                                });
                                        })
                                        .catch(error =>
                                        {
                                            if (!window.cordova)
                                                return;

                                            reject(error);
                                        });

                                    return;
                                }

                                self._setSignInPropertiesAsync(result)
                                    .finally(() =>
                                    {
                                        if (!window.cordova)
                                            resolve();
                                    });
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                },

                // Public Methods
                clearUser: function ()
                {
                    this.additionalUserInfoSet(null);
                    this.providerIdSet(null);
                    this.userSet(null);
                },
                createUserWithEmailAndPasswordAsync: function (email, password)
                {
                    return (
                        firebase.auth()
                            .createUserWithEmailAndPassword(email, password)
                    );
                },
                getFileDownloadUrlAsync: function (path, context)
                {
                    return (
                        firebase.storage().ref().child(this._processPathVariables(path, context))
                            .getDownloadURL()
                    );
                },
                initializeAsync: function ()
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        if (!window.application)
                            reject("Application not running");
                        else
                        {
                            firebase.initializeApp(self.configurationGet());

                            firebase.auth().onAuthStateChanged(user =>
                            {
                                if (!user || !user.providerData || !user.providerData.length)
                                    self.clearUser();
                                else
                                {
                                    self.providerIdSet(user.providerData[0].providerId);
                                    self.userSet(user);
                                    self.onSignedIn();
                                }

                                self.triggerHandler("onAuthStateChanged", user);
                            });

                            resolve();
                        }
                    });
                },
                offAsync: function (path, context, handler)
                {
                    firebase.database().ref(this._processPathVariables(path, context)).off("value", handler);
                },
                onAsync: function (path, context, handler, ignoreConnectionState)
                {
                    // TODO: .on("value", handler) does not return a promise
                    return (
                        this
                            ._executePromiseWithTimeout(
                                firebase.database().ref(this._processPathVariables(path, context)).on("value", handler),
                                ignoreConnectionState
                            )
                    );
                },
                onceAsync: function (path, context, query, ignoreConnectionState)
                {
                    return (
                        this
                            ._executePromiseWithTimeout((
                                query
                                    ? query.applyToRef(firebase.database().ref(this._processPathVariables(path, context)))
                                    : firebase.database().ref(this._processPathVariables(path, context))
                            ).once("value"), ignoreConnectionState)
                    );
                },
                pushAsync: function (path, context, data, ignoreConnectionState)
                {
                    return (
                        this._executePromiseWithTimeout(
                            firebase.database().ref(this._processPathVariables(path, context)).push(data),
                            ignoreConnectionState
                        )
                    );
                },
                sendPasswordResetEmail: function (email)
                {
                    return (
                        firebase.auth()
                            .fetchSignInMethodsForEmail(email)
                            .then(methods =>
                            {
                                if (methods?.contains("password"))
                                    return firebase.auth().sendPasswordResetEmail(email);

                                if (methods?.contains("facebook.com"))
                                {
                                    return Promise.reject({
                                        code: "auth/user-auth-method-facebook"
                                    });
                                }

                                if (methods?.contains("google.com"))
                                {
                                    return Promise.reject({
                                        code: "auth/user-auth-method-google"
                                    });
                                }

                                return Promise.reject({
                                    code: "auth/user-not-found"
                                });
                            })
                    );
                },
                setAsync: function (path, o, context, ignoreConnectionState)
                {
                    return (
                        this._executePromiseWithTimeout(
                            firebase.database().ref(this._processPathVariables(path, context)).set(o),
                            ignoreConnectionState
                        )
                    );
                },
                signInWithAppleAuthProviderAsync: function ()
                {
                    var
                        self = this,
                        provider = new firebase.auth.OAuthProvider("apple.com");

                    provider.addScope("email");
                    provider.addScope("name");

                    return self._signInWithProviderAsync(provider);
                },
                signInWithCredentialAsync: function (credential)
                {
                    var
                        self = this;

                    return new Promise((resolve, reject) =>
                    {
                        firebase.auth()
                            .signInAndRetrieveDataWithCredential(credential)
                            .then(result =>
                            {
                                result.credential.idToken = credential.idToken;

                                self._setSignInPropertiesAsync(result)
                                    .finally(() =>
                                    {
                                        resolve();
                                    });
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                },
                signInWithEmailAndPasswordAsync: function (email, password)
                {
                    var
                        self = this;

                    self.providerIdSet(null);

                    return new Promise((resolve, reject) =>
                    {
                        firebase.auth()
                            .signInWithEmailAndPassword(email, password)
                            .then(result =>
                            {
                                self._setSignInPropertiesAsync(result)
                                    .finally(() =>
                                    {
                                        resolve();
                                    });
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                },
                signInWithFacebookAuthProviderAsync: function ()
                {
                    return this._signInWithProviderAsync(new firebase.auth.FacebookAuthProvider());
                },
                signInWithGoogleAuthProviderAsync: function ()
                {
                    return this._signInWithProviderAsync(new firebase.auth.GoogleAuthProvider());
                },
                signOutAsync: function ()
                {
                    return (
                        firebase.auth()
                            .signOut()
                            .then(() =>
                            {
                                self.onSignedOut();
                            })
                    );
                },
                updateAsync: function (updates, context, ignoreConnectionState)
                {
                    var
                        updatesInternal = {};

                    for (let property in updates)
                        updatesInternal[this._processPathVariables(property, context)] = updates[property];

                    return (
                        this._executePromiseWithTimeout(
                            firebase.database().ref().update(updatesInternal), ignoreConnectionState
                        )
                    );
                },
                uploadFileFromDataUrlStringAsync: function (path, dataUrlString, context)
                {
                    return (
                        firebase.storage().ref().child(this._processPathVariables(path, context))
                            .putString(dataUrlString, "data_url")
                    );
                },

                // Event Handlers
                onLaunchAppFromLink: function ()
                {
                    // TODO
                },
                onSignedIn: function ()
                {
                    this.onSignedOut();

                    firebase
                        .database()
                        .ref(".info/connected")
                        .on("value", this.onConnectionStateChanged);
                },
                onSignedOut: function ()
                {
                    firebase
                        .database()
                        .ref(".info/connected")
                        .off("value", this.onConnectionStateChanged);
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classFactory.create({
                name: "Query",
                namespace: classConstructor,
                properties: [
                    { name: "endAt", type: "string" },
                    { name: "limitToFirst", type: "int" },
                    { name: "limitToLast", type: "int" },
                    { name: "orderByKey", type: "boolean" },
                    { name: "startAt", type: "string" }
                ],
                createPropertyDefaults: namespace =>
                {
                    return {
                        endAt: null,
                        limitToFirst: null,
                        limitToLast: null,
                        orderByKey: null,
                        startAt: null
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        // Public Methods
                        applyToRef: function (ref)
                        {
                            var
                                endAt = this.endAtGet(),
                                limitToFirst = this.limitToFirstGet(),
                                limitToLast = this.limitToLastGet(),
                                orderByKey = this.orderByKeyGet(),
                                startAt = this.startAtGet();

                            if (orderByKey === true)
                                ref = ref.orderByKey();

                            if (startAt !== null)
                                ref = ref.startAt(startAt);

                            if (endAt !== null)
                                ref = ref.endAt(endAt);

                            if (limitToFirst !== null)
                                ref = ref.limitToFirst(limitToFirst);

                            if (limitToLast !== null)
                                ref = ref.limitToLast(limitToLast);

                            return ref;
                        }
                    };
                }
            });
        }
    });

    // OData Batch Request
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "ODataBatchRequest",
        inherits: "AjaxRequest",
        properties: [
            { name: "baseUrl", type: "string" },
            { name: "requests" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                requests: [],
                type: "BATCH"
            };
        },
        createConstructor: namespace =>
        {
            return function ()
            {
                this.httpHeaderManager = new namespace.HttpHeaderManager();
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createBatchBody: function (requests, boundary)
                {
                    var
                        changesetBoundary = null,
                        body = [],
                        baseUrl = this.baseUrlGet();

                    for (var i = 0; i < requests.length; i++)
                    {
                        var
                            request = requests[i],
                            settings = request.settingsGet(),
                            type = settings.type.toUpperCase(),
                            url = `/${settings.url.substr(baseUrl.length)}`;

                        if (!changesetBoundary)
                        {
                            switch (type)
                            {
                                case "DELETE":
                                case "MERGE":
                                case "PATCH":
                                case "POST":
                                case "PUT":

                                    if (i === 0)
                                        body.push(`--${boundary}`);

                                    changesetBoundary = `changeset_${new Date().getTime()}_${i}`;
                                    body.push(`Content-Type: multipart/mixed; boundary=${changesetBoundary}`);
                                    body.push(String.empty);
                                    body.push(`--${changesetBoundary}`);
                                    break;
                                default:
                                    body.push(`--${boundary}`);
                                    break;
                            }
                        }
                        else
                        {
                            switch (type)
                            {
                                case "DELETE":
                                case "MERGE":
                                case "PATCH":
                                case "POST":
                                case "PUT":
                                    body.push(`--${changesetBoundary}`);
                                    break;
                                default:
                                    body.push(`--${changesetBoundary}--`);
                                    changesetBoundary = null;
                                    break;
                            }
                        }

                        body.push("Content-Type: application/http");
                        body.push("Content-Transfer-Encoding: binary");
                        body.push(String.empty);

                        body.push(`${type} ${url} HTTP/1.1`);

                        body.push(`Host: ${location.host}`);
                        body.push("Content-Type: application/json");
                        body.push("Prefer: return=representation");
                        body.push(`Content-ID: ${i}`);

                        if (!settings.data)
                            body.push(String.empty);
                        else
                        {
                            body.push(`Content-Length: ${settings.data.byteLength()}`);
                            body.push(String.empty);

                            body.push(settings.data);
                            body.push(String.empty);
                        }
                    }

                    if (changesetBoundary)
                    {
                        body.push(`--${changesetBoundary}--`);
                        changesetBoundary = null;
                    }

                    body.push(`--${boundary}--`);

                    return body.join("\r\n");
                },
                _createDoneData: function (responses)
                {
                    var
                        requests = this.requestsGet();

                    if (requests.length !== responses.length)
                        console.error("The number of responses does not match the number of requests");

                    var
                        data = [];

                    for (var i = 0; i < requests.length; i++)
                    {
                        data.push({
                            request: requests[i],
                            response: responses[i]
                        });
                    }

                    return data;
                },
                _parseBatchResponse: function (batchResponse)
                {
                    batchResponse = batchResponse.replace(/\r\n/gi, "\n");

                    var
                        indexOfLineBreak = batchResponse.indexOf("\n"),
                        boundary = batchResponse.substr(batchResponse, indexOfLineBreak);

                    if (!boundary.length)
                        console.error("Cannot determine boundary.");

                    var
                        responses = [],
                        responseSections = batchResponse.split(boundary);

                    for (var i = 0; i < responseSections.length; i++)
                    {
                        var
                            responseSection = responseSections[i].trim([" ", "\n"]);

                        if (!responseSection.length || responseSection === "--")
                            continue;

                        var
                            response = {};

                        // Get Request Headers
                        var
                            indexOfDoubleLineBreak = responseSection.indexOf("\n\n");

                        if (indexOfDoubleLineBreak === -1)
                            continue;

                        var
                            requestHeaders = responseSection.substr(0, indexOfDoubleLineBreak);

                        responseSection = responseSection.substr(indexOfDoubleLineBreak + 2);

                        // Check for Changeset
                        this.httpHeaderManager.setHeaderText(requestHeaders);

                        var
                            contentTypeHeader = this.httpHeaderManager.getHeader("Content-Type");

                        if (contentTypeHeader?.value.toLowerCase() === "multipart/mixed")
                        {
                            Array.prototype.push.apply(responses, this._parseBatchResponse(responseSection));
                            continue;
                        }

                        responses.push(response);

                        // Get Response Headers
                        indexOfDoubleLineBreak = responseSection.indexOf("\n\n");

                        var
                            responseHeaders;

                        if (indexOfDoubleLineBreak === -1)
                        {
                            responseHeaders = responseSection;
                            responseSection = String.empty;
                        }
                        else
                        {
                            responseHeaders = responseSection.substr(0, indexOfDoubleLineBreak);
                            responseSection = responseSection.substr(indexOfDoubleLineBreak + 2);
                        }

                        var
                            statusMatches = /HTTP\/1.1 ([0-9]+)( (.*))?/g.exec(responseHeaders);

                        if (statusMatches)
                        {
                            response.status = parseInt(statusMatches[1]);

                            if (statusMatches.length >= 3)
                                response.statusText = statusMatches[3];
                        }

                        response.responseText = responseSection;
                        response.responseType = "json";

                        // Get Json
                        try { response.response = response.responseText.fromJson(); }
                        catch (e) { /* Continue regardless of error */ }
                    }

                    return responses;
                },

                // Public Methods
                executeAsync: function ()
                {
                    var
                        self = this,
                        boundary = `batch_${new Date().getTime()}`,
                        settings = Object.extend(true, {}, {
                            data: self._createBatchBody(self.requestsGet(), boundary),
                            contentType: `multipart/mixed; boundary="${boundary}"`
                        }, self.settingsGet()),
                        promise = Promise.public();

                    self._ajax(settings)
                        .then(data =>
                        {
                            const
                                responses = self._parseBatchResponse(data);

                            for (var i = 0; i < responses.length; i++)
                            {
                                if (!responses[i].status || responses[i].status >= 400)
                                {
                                    var
                                        error = window.serverErrorHelper.processError(responses[i]);

                                    if (error.type === "ValidationApiException")
                                        promise.reject(error);
                                    else
                                        self._ajaxCallFailed(error, settings, promise);

                                    return;
                                }
                            }

                            promise.resolve(self._createDoneData(responses));
                        })
                        .catch(error =>
                        {
                            promise.reject(error);
                        })
                        .finally(() => { self = null; });

                    return promise;
                }
            };
        }
    });

    // Web Client
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "WebClient",
        properties: [
            { name: "baseUrl", type: "string" },
            { name: "onConnected", type: "function" },
            { name: "onDisconnected", type: "function" },
            { name: "onRequestAuthenticationData", type: "function" }
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                baseUrl: window.applicationInformation.virtualDirectory
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _createAuthenticationHeaders: function ()
                {
                    const
                        headers = {},
                        onRequestAuthenticationData = this.onRequestAuthenticationDataGet(),
                        authenticationData = onRequestAuthenticationData ? onRequestAuthenticationData() : null;

                    if (authenticationData)
                    {
                        switch (authenticationData.scheme)
                        {
                            case "Cookies":
                                headers["X-XSRF-Token"] = authenticationData.antiForgeryToken;
                                break;
                            case "Bearer":
                                headers["Authorization"] = `Bearer ${authenticationData.accessToken}`;
                                break;
                        }
                    }

                    return headers;
                },
                _createDefaultHeaders: function ()
                {
                    return Object.extend(true, {}, window.objectHelper.cloneObject(namespace.WebClient.staticHeaders), this._createAuthenticationHeaders());
                },

                // Public Methods
                createHtmlGetRequest: function (relativeUrl, additionalHeaders, showLoading)
                {
                    return new namespace.AjaxRequest({
                        settings: {
                            type: "GET",
                            headers: Object.extend(true, {}, this._createDefaultHeaders(), additionalHeaders),
                            url: this.baseUrlGet() + relativeUrl,
                            showLoading: showLoading === true || showLoading === false ? showLoading : true
                        },
                        type: "HTML",
                        webApiClient: this
                    });
                }
            };
        },
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.staticHeaders = {};

            classConstructor.addStaticHeader = (name, value) =>
            {
                classConstructor.staticHeaders[name] = value;
            };
        }
    });

    // WebApi Client
    classFactory.create({
        namespace: "seriouslyrad.server",
        name: "WebApiClient",
        inherits: "WebClient",
        properties: [
            { name: "onAuthenticatedAsync", type: "function" },
            { name: "onUnauthenticated", type: "function" },
        ],
        createPropertyDefaults: namespace =>
        {
            return {
                baseUrl: window.applicationInformation.serverVirtualDirectory
            };
        },
        createPrototype: namespace =>
        {
            return {
                // "Protected" Methods
                _addQueryStringOption: function (optionString, name, value)
                {
                    if (value)
                        optionString += `${(optionString.length ? "&" : String.empty)}$${name}=${encodeURIComponent(value)}`;

                    return optionString;
                },
                _convertExpressionToODataFilter: function (expression)
                {
                    var
                        self = this,
                        filter = String.empty;

                    if (objectHelper.typeOf(expression) === "string")
                    {
                        filter = expression;
                        return filter;
                    }

                    if (expression instanceof seriouslyrad.ComparisonExpression)
                    {
                        var
                            oDataPropertyPath = window.oDataHelper.objectPropertyPathToODataPropertyPath(expression.pathGet()),
                            oDataValue,
                            value = expression.valueGet(),
                            valueType = objectHelper.typeOf(value);

                        if (value === null)
                            oDataValue = "null";
                        else
                        {
                            switch (valueType)
                            {
                                case "boolean":
                                    oDataValue = value ? "true" : "false";
                                    break;
                                case "date":
                                    oDataValue = value.toString("yyyy-MM-ddTHH:mm:ss.fffffffZ");
                                    break;
                                case "number":
                                    oDataValue = value.toString();
                                    break;
                                case "string":
                                    oDataValue = value.isGuid() ? value : `'${value}'`;
                                    break;
                                default:
                                    console.errorAndThrow(`Value type '${valueType}' not supported`);
                            }
                        }

                        var
                            operator = expression.operatorGet();

                        switch (operator)
                        {
                            case seriouslyrad.ComparisonExpression.operators.contains:
                                filter = `indexof(${oDataPropertyPath}, ${(oDataValue.startsWith("'") ? oDataValue : `'${oDataValue}'`)}) ge 0`;
                                break;
                            case seriouslyrad.ComparisonExpression.operators.equals:
                                filter = `${oDataPropertyPath} eq ${oDataValue}`;
                                break;
                            case seriouslyrad.ComparisonExpression.operators.greaterThan:
                                filter = `${oDataPropertyPath} gt ${oDataValue}`;
                                break;
                            case seriouslyrad.ComparisonExpression.operators.greaterThanOrEqualTo:
                                filter = `${oDataPropertyPath} ge ${oDataValue}`;
                                break;
                            case seriouslyrad.ComparisonExpression.operators.lessThan:
                                filter = `${oDataPropertyPath} lt ${oDataValue}`;
                                break;
                            case seriouslyrad.ComparisonExpression.operators.lessThanOrEqualTo:
                                filter = `${oDataPropertyPath} le ${oDataValue}`;
                                break;
                            default:
                                console.errorAndThrow("Expression operator not supported");
                        }

                        return filter;
                    }

                    if (expression instanceof seriouslyrad.AndExpression)
                    {
                        expression.expressionsGet().each(item =>
                        {
                            filter += `${(filter.length ? " and " : String.empty)}(${self._convertExpressionToODataFilter(item)})`;
                        });

                        return filter;
                    }

                    if (expression instanceof seriouslyrad.OrExpression)
                    {
                        expression.expressionsGet().each(item =>
                        {
                            filter += `${(filter.length ? " or " : String.empty)}(${self._convertExpressionToODataFilter(item)})`;
                        });

                        return filter;
                    }

                    if (expression instanceof seriouslyrad.NotExpression)
                    {
                        filter += `not (${self._convertExpressionToODataFilter(expression.expressionGet())})`;

                        return filter;
                    }

                    console.errorAndThrow("Expression type not supported");
                },
                _createDefaultHeaders: function ()
                {
                    return Object.extend(true, {}, window.objectHelper.cloneObject(namespace.WebApiClient.staticHeaders), this._createAuthenticationHeaders());
                },

                // Public Methods
                createApiMethodRequest: function (apiName, methodName, data, additionalHeaders, showLoading)
                {
                    return new namespace.AjaxRequest({
                        settings: {
                            type: "POST",
                            headers: Object.extend(true, {}, this._createDefaultHeaders(), additionalHeaders),
                            data: data ? data.toJson() : null,
                            dataType: "json",
                            contentType: "application/json",
                            url: `${this.baseUrlGet()}api/${apiName}/${methodName}`,
                            showLoading: showLoading === true || showLoading === false ? showLoading : true
                        },
                        type: "API",
                        webApiClient: this
                    });
                },
                createBatchRequest: function (requests, additionalHeaders, showLoading)
                {
                    var
                        baseUrl = this.baseUrlGet();

                    return new namespace.ODataBatchRequest({
                        settings: {
                            type: "POST",
                            headers: Object.extend(true, {}, this._createDefaultHeaders(), additionalHeaders),
                            url: baseUrl + "odata/$batch",
                            showLoading: showLoading === true || showLoading === false ? showLoading : true
                        },
                        baseUrl: baseUrl,
                        requests: requests,
                        webApiClient: this
                    });
                },
                createEntityDeleteRequest: function (entitySetName, id, additionalHeaders, showLoading)
                {
                    return this.createODataMethodRequest(
                        `${entitySetName}(${id})`,
                        "DELETE",
                        null,
                        null,
                        null,
                        additionalHeaders,
                        showLoading
                    );
                },
                createEntityGetRequest: function (entitySetName, id, columns, additionalHeaders, showLoading)
                {
                    return this.createODataMethodRequest(
                        `${entitySetName}(${id})`,
                        "GET",
                        null,
                        {
                            columns: columns
                        },
                        additionalHeaders,
                        showLoading
                    );
                },
                createEntityListChildrenRequest: function (entitySetName, id, path, filter, orderBy, columns, skip, take, additionalHeaders, showLoading)
                {
                    return this.createODataMethodRequest(
                        `${entitySetName}(${id})/${path}`,
                        "GET",
                        null,
                        {
                            filter: filter,
                            orderBy: orderBy,
                            columns: columns,
                            skip: skip,
                            take: take,
                            count: true
                        },
                        additionalHeaders,
                        showLoading
                    );
                },
                createEntitySaveRequest: function (entitySetName, entity, originalEntity, additionalHeaders, showLoading)
                {
                    var
                        path = entitySetName,
                        type = "POST",
                        data;

                    if (originalEntity?.rowVersion)
                    {
                        path = `${entitySetName}(${originalEntity.id})`;
                        type = "PATCH";

                        data = {};

                        window.objectHelper.copySimpleProperties(entity, data, property =>
                        {
                            return !DeepObjectValueComparer.default.compare(originalEntity[property], entity[property]);
                        });

                        data.id = originalEntity.id;
                        data.rowVersion = originalEntity.rowVersion;
                    }
                    else
                    {
                        data = {};
                        window.objectHelper.copySimpleProperties(entity, data);
                    }

                    return this.createODataMethodRequest(
                        path,
                        type,
                        data,
                        null,
                        {
                            "Prefer": "return=representation"
                        },
                        additionalHeaders,
                        showLoading
                    );
                },
                createEntitySetSaveRequests: function (entitySetName, currentSet, originalSet, additionalHeaders, showLoading)
                {
                    var
                        requests = [];

                    if (originalSet.length)
                    {
                        originalSet
                            .where(item => !currentSet.any(itemInner => itemInner.id === item.id))
                            .each(item =>
                            {
                                requests.push(
                                    window.application.webApiClient
                                        .createEntityDeleteRequest(entitySetName, item.id)
                                );
                            });
                    }

                    currentSet
                        .each(item =>
                        {
                            var
                                originalRecord = originalSet.firstOrDefault(itemInner => itemInner.id === item.id);

                            requests.push(
                                window.application.webApiClient
                                    .createEntitySaveRequest(entitySetName, item, originalRecord, additionalHeaders, showLoading)
                            );
                        });

                    return requests;
                },
                createEntitySearchRequest: function (entitySetName, filter, orderBy, columns, skip, take, additionalHeaders, showLoading)
                {
                    return this.createODataMethodRequest(
                        entitySetName,
                        "GET",
                        null,
                        {
                            filter: filter,
                            orderBy: orderBy,
                            columns: columns,
                            skip: skip,
                            take: take,
                            count: true
                        },
                        additionalHeaders,
                        showLoading
                    );
                },
                createFileUploadRequest: function (apiName, methodName, data, additionalHeaders, showLoading)
                {
                    return new namespace.AjaxRequest({
                        settings: {
                            type: "POST",
                            headers: Object.extend(true, {}, this._createDefaultHeaders(), additionalHeaders),
                            data: data,
                            url: `${this.baseUrlGet()}api/${apiName}/${methodName}`,
                            cache: false,
                            contentType: false,
                            processData: false,
                            showLoading: showLoading === true || showLoading === false ? showLoading : true
                        },
                        type: "API",
                        webApiClient: this
                    });
                },
                createODataMethodRequest: function (path, type, data, options, additionalHeaders, showLoading)
                {
                    var
                        optionsString = String.empty;

                    if (options)
                    {
                        if (options.filter instanceof seriouslyrad.Expression)
                            optionsString = this._addQueryStringOption(optionsString, "filter", this._convertExpressionToODataFilter(options.filter));
                        else
                            optionsString = this._addQueryStringOption(optionsString, "filter", options.filter);

                        optionsString = this._addQueryStringOption(optionsString, "orderBy", window.oDataHelper.objectPropertyPathToODataPropertyPath(options.orderBy));

                        if (options.columns)
                        {
                            var
                                selectExpandInfo = seriouslyrad.server.WebApiClient.SelectExpandInfo.fromColumnList(options.columns).convertToQuery();

                            optionsString = this._addQueryStringOption(optionsString, "select", selectExpandInfo.select);
                            optionsString = this._addQueryStringOption(optionsString, "expand", selectExpandInfo.expand);
                        }

                        optionsString = this._addQueryStringOption(optionsString, "skip", options.skip);
                        optionsString = this._addQueryStringOption(optionsString, "top", options.take);
                        optionsString = this._addQueryStringOption(optionsString, "count", options.count === true);
                    }
                    
                    return new namespace.AjaxRequest({
                        settings: {
                            type: type,
                            headers: Object.extend(true, {}, this._createDefaultHeaders(), additionalHeaders),
                            data: data ? data.toJson() : null,
                            dataType: "json",
                            contentType: "application/json",
                            url: `${this.baseUrlGet()}odata/${path}${(optionsString !== String.empty ? `?${optionsString}` : String.empty) }`,
                            showLoading: showLoading === true || showLoading === false ? showLoading : true
                        },
                        type: "ODATA",
                        webApiClient: this
                    });
                }
            };
        },
        classCreated: (namespace, WebApiClient) =>
        {
            WebApiClient.staticHeaders = {};

            WebApiClient.SelectExpandInfo = classFactory.create({
                namespace: WebApiClient,
                createConstructor: namespace =>
                {
                    return function (name)
                    {
                        this.name = name !== undefined ? name : null;
                        this.selects = [];
                        this.expands = [];
                    };
                },
                createPrototype: namespace =>
                {
                    return {
                        convertToQuery: function (nested)
                        {
                            var
                                select = this.selects.join(","),
                                expand = this.expands.select(item => item.convertToQuery(true)).join(",");

                            if (nested)
                            {
                                var
                                    result = "(";

                                if (select)
                                {
                                    if (result.length > 1)
                                        result += ";";

                                    result += `$select=${select}`;
                                }

                                if (expand)
                                {
                                    if (result.length > 1)
                                        result += ";";

                                    result += `$expand=${expand}`;
                                }

                                result += ")";

                                return this.name + result;
                            }
                            else
                            {
                                return {
                                    select: select,
                                    expand: expand
                                };
                            }
                        }
                    };
                },
                classCreated: (namespace, SelectExpandInfo) =>
                {
                    SelectExpandInfo.fromColumnList = propertyList =>
                    {
                        var
                            result = new WebApiClient.SelectExpandInfo(),
                            currentResultPart;

                        propertyList
                            .orderBy(item => item)
                            .each(path =>
                            {
                                var
                                    pathParts = path.split(".");

                                currentResultPart = result;

                                pathParts.each((pathPart, index) =>
                                {
                                    if (index < pathParts.length - 1)
                                    {
                                        var
                                            temp = currentResultPart.expands.singleOrDefault(expand => expand.name === pathPart);

                                        if (!temp)
                                        {
                                            temp = new WebApiClient.SelectExpandInfo(pathPart);
                                            currentResultPart.expands.push(temp);
                                        }

                                        currentResultPart = temp;
                                    }
                                    else
                                        currentResultPart.selects.push(pathPart);
                                });
                            });

                        return result;
                    };
                }
            });

            WebApiClient.addStaticHeader = (name, value) =>
            {
                WebApiClient.staticHeaders[name] = value;
            };
        }
    });

    // #endregion
